import { getPreferredScrollBehavior } from '@/utils/motion';

const SCROLLABLE_OVERFLOW_VALUES = new Set(['auto', 'scroll']);

type ScrollAlign = 'nearest' | 'start';

function findScrollContainer(element: HTMLElement): HTMLElement | null {
  let parent = element.parentElement;
  while (parent && parent !== document.body && parent !== document.documentElement) {
    const canScroll = SCROLLABLE_OVERFLOW_VALUES.has(getComputedStyle(parent).overflowY);
    if (canScroll && parent.scrollHeight > parent.clientHeight) return parent;
    parent = parent.parentElement;
  }
  return null;
}

export function scrollIntoContainer(element: HTMLElement, align: ScrollAlign = 'nearest') {
  const container = findScrollContainer(element);
  if (!container) return;

  const containerRect = container.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  const marginTop = Number.parseFloat(getComputedStyle(element).scrollMarginTop) || 0;
  const offsetToTop = elementRect.top - marginTop - containerRect.top;
  const behavior = getPreferredScrollBehavior();

  if (align === 'start' || offsetToTop < 0) {
    container.scrollBy({ top: offsetToTop, behavior });
  } else if (elementRect.bottom > containerRect.bottom) {
    container.scrollBy({ top: elementRect.bottom - containerRect.bottom, behavior });
  }
}
